<div class="select-wrapper" *ngIf="currentConfig">
	<select (change)="onChangeConfig($event.target.value)" class="professional-select bg-transparent">
		<option *ngFor="let configItem of availableConfigs" [value]="configItem.config" [selected]="currentConfig === configItem.config">
			{{ configItem.customerName }} ({{ configItem.allowedAccessLevel }})
		</option>
	</select>

</div>